<div class="headertop" id="section1">
    <div class="container">
        <div class="headertop-left">MatchMove now supports Apple Pay. <b><a
                href="/apple-pay.html"> FIND OUT MORE <i class="fa fa-external-link"
                    aria-hidden="true"></i></a></b></div>
    </div>
</div>